import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";

@Component({
  selector: 'kng-search-input-button',
  templateUrl: './kng-search-input.component.html',
  styleUrls: []
})
export class KngSearchInputComponent implements OnInit{

  @Input() delay: number = 0;
  @Input() disabled: boolean;
  @Input() focus: boolean;
  @Input() id: string;
  @Input() additionalClass: string;
  @Output() kngOnSearch: EventEmitter<any> = new EventEmitter();
  @Output() kngOnChange: EventEmitter<any> = new EventEmitter();
  @Input() searchText: string;
  @Output() searchTextChange = new EventEmitter();
  @Input() placeholder: string;

  public form: FormGroup;

  constructor(private fb: FormBuilder) {
  }

  ngOnInit(){
    this.form = this.fb.group({
      searchText: this.searchText
    });

    this.form.controls['searchText'].valueChanges
      .debounceTime(this.delay)
      .subscribe(value=>{
      this.searchTextChange.emit(value);

      if (this.kngOnChange) {
        this.kngOnChange.emit(value)
      }
    });
  }

  clearInput() {
    this.form.controls['searchText'].setValue('');

  }

  onSearch() {
    if (this.kngOnSearch) {
      this.kngOnSearch.emit(this.searchText)
    }
  }

  onChange($event) {
    console.log("something changed");
    if (this.kngOnChange) {
      this.kngOnChange.emit($event)
    }
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/kng-search-input/kng-search-input.component.ts